<template>
  <div id="history-datacleansing-page">
    <transition name="block">
      <div class="px-2" style="margin-top: 15px;">
        <div class="card card-default shade">
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h3 style="font-size: 20px">
                      <i class="bi bi-clock-history"></i> Riwayat Data Cleansing
                    </h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      Halaman untuk melihat riwayat data cleansing yang pernah
                      dilakukan.
                    </p>
                  </div>
                  <div class="col-md-12 mt-3">
                    <div class="d-flex align-items-center">
                      <router-link to="cleansing" class="ml-auto mb-2">
                        <button class="btn btn-lg btn-success" type="button">
                          <i
                            class="bi bi-chevron-double-left mr-1"
                            style="font-size: 10px"
                          ></i>
                          Kembali
                        </button>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-12 table-responsive" id="table">
                    <table class="table table-bordered" id="historycleantable">
                      <thead>
                        <tr>
                          <th>User</th>
                          <th>ID Task SiIteung</th>
                          <th>Jenis Data</th>
                          <th><center>Periode</center></th>
                          <th><center>Tanggal Dibuat</center></th>
                          <th><center>File Excel</center></th>
                          <th><center>Aksi</center></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="currentModal.data"
      :static="true"
    />
  </div>
</template>
<script>
import $ from "jquery";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_update_periode from "@/views/components/datacleansing/modal_update_periode.vue";
import moment from "moment";

export default {
  name: "HistoryDataCleansing",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      history_data: [],
      modal_key: 10,
      currentModal: null,
    };
  },
  methods: {
    getHistory: function() {
      let api =
        process.env.VUE_APP_API_URL + "get-datacleansing/" + this.id_project;
      this.$http.get(api).then((response) => {
        this.history_data = response.data;
        this.assemblyData(this.history_data);
      });
    },
    assemblyData: function(data) {
      this.table = $("#historycleantable").DataTable({
        autoWidth: false,
        scrollX: true,
        destroy: true,
        ordering: false,
        data: data,
        language: {
          emptyTable: "Mohon maaf, data tidak tersedia!",
        },
        columns: [
          { data: "User", defaultContent: "-" },
          { data: "ID Task SiIteung", defaultContent: "-" },
          { data: "Jenis Data", defaultContent: "-" },
          { data: "Periode", defaultContent: "-" },
          { data: "File Excel", defaultContent: "-" },
          { data: "Created At", defaultContent: "-" },
          { data: "URL", defaultContent: "-" },
        ],
        columnDefs: [
          {
            render: function(data, type, row) {
              let div = '<div style="width:100px;">' + row.user + "</div>";
              return div;
            },
            orderable: false,
            targets: 0,
          },
          {
            render: function(data, type, row) {
              let id_task = "";
              if (row.id_task) {
                id_task = row.id_task;
              } else {
                id_task = "-";
              }
              let div = '<div style="width:100px;">' + id_task + "</div>";
              return div;
            },
            orderable: false,
            targets: 1,
          },
          {
            render: function(data, type, row) {
              let media = "";
              if (row.jenis_data == "medkon") {
                media = "Media Konvensional";
              } else {
                media = "Media Sosial";
              }
              let div = '<div style="width:150px">' + media + "</div>";
              return div;
            },
            orderable: false,
            targets: 2,
          },
          {
            render: function(data, type, row) {
              let div = "<center>" + row.periode + "</center>";
              return div;
            },
            orderable: true,
            targets: 3,
          },
          {
            render: function(data, type, row) {
              let div =
                "<center>" +
                moment(row.created_at.$date).format("YYYY-MM-DD HH:mm:ss") +
                "</center>";
              return div;
            },
            orderable: true,
            targets: 4,
          },
          {
            render: function(data, type, row) {
              let div =
                '<center><button id="download-file" class="btn btn-sm btn-success" data-id="' +
                row._id.$oid +
                '"><i class="bi bi-download mr-1" style="font-size:12px"></i> Download File </button></center>';
              return div;
            },
            orderable: false,
            targets: 5,
          },
          {
            render: function(data, type, row) {
              let btn =
                '<center><button id="edit-history" class="btn btn-sm btn-complete" data-id="' +
                row._id.$oid +
                '"><i class="bi bi-pencil-square"></i></button></center>';
              return btn;
            },
            orderable: false,
            targets: 6,
          },
        ],
      });
    },
    downloadFile: function(url) {
      window.open(url);
    },
    editHistory: function(data) {
      let periode_date = null;
      if (data.periode) {
        periode_date = data.periode.replace(/ - /g, "&").split("&");
      }
      this.currentModal = {
        title: "Update Periode Data",
        subtitle: "Silahkan masukan inputan yang tersedia",
        component: modal_update_periode,
        data: {
          id: data._id.$oid,
          tipe: data.jenis_data,
          file_input: data.url.substring(data.url.lastIndexOf("/") + 1),
          id_task: data.id_task ? data.id_task : "-",
          periode: {
            start: periode_date[0],
            end: periode_date[1],
          },
        },
      };
      this.modal_key++;
    },
  },
  mounted() {
    let self = this;
    self.getHistory();
    self.$("#historycleantable").on("click", "#download-file", function() {
      let id = self.$(this).attr("data-id");
      let data = self.history_data.find((el) => el._id.$oid == id);
      let url = data.url;
      self.downloadFile(url);
    });
    self.$("#historycleantable").on("click", "#edit-history", function() {
      let id = self.$(this).attr("data-id");
      let data = self.history_data.find((el) => el._id.$oid == id);
      self.editHistory(data);
    });
  },
};
</script>
